// Load url into a frame without pushing history. A frame that promotes its
// navigations to history (data-turbo-action) replaces the current entry; any
// other frame leaves history alone.
//
// Setting frame.src or calling frame.reload() instead repeats the action of
// the frame's last navigation, so a refresh after a link click would push a
// duplicate entry.
export default function refreshFrame(frame, url) {
  const options = {frame: frame.id}
  if (frame.dataset.turboAction)
    options.action = 'replace'

  Turbo.visit(url, options)
}
